"use client";
import { LocationSearch as LocationSearchUI } from "@repo/ui-parkmobile/LocationSearch";
import type { LocationSearch } from "@/generated/sb";
import { storyblokEditable } from "@storyblok/react/rsc";
import { trackSearchLocation } from "@/utils/trackingScripts";

interface LocationSearchProps {
  blok: LocationSearch;
  pageType?: "default" | "location";
  section?: string;
}

export default function LocationSearch({
  blok,
  pageType = "default",
  section,
}: LocationSearchProps) {
  if (!blok) {
    return null;
  }

  const handleSearch = (data: {
    destination: string;
    startDate: Date | null;
    endDate: Date | null;
    filterApplied: boolean;
    filterType?: string[];
  }) => {
    trackSearchLocation({
      section: section || "Park. Pay. Go.",
      config: "searchField",
      search_text: data.destination,
      results_count: 0,
    });
  };

  const handleFilterClick = () => {
    console.log("Filter clicked");
  };

  return (
    <LocationSearchUI
      {...storyblokEditable(blok)}
      onSearch={handleSearch}
      onFilterClick={handleFilterClick}
      pageType={pageType}
      showDropShadow={blok.showDropShadow}
    />
  );
}
